import gql from 'graphql-tag';

export default gql`
{
  pageType @client {
    id
    type
  }
}
`;
